import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.extraction');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-extraction',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.extraction/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageExtractionComponent implements OnInit {
    public loading: boolean = true;
    public contextLoading: boolean = false;
    public extracting: boolean = false;
    public reviewing: boolean = false;
    public errorMessage: string = '';
    public successMessage: string = '';
    public documents: any[] = [];
    public contexts: any[] = [];
    public selectedDocumentId: string = '';
    public selectedContextId: string = '';
    public selectedContext: any = {};
    public run: any = null;
    public batchResult: any = null;
    public extractionRuns: any[] = [];
    public currentRunId: string = '';
    public selectedRunId: string = '';
    public quality: any = {};
    public ontology: any = {};
    public candidates: any = {
        entity_candidates: [],
        event_candidates: [],
        relation_candidates: []
    };
    public activeTab: string = 'entity';
    public statusFilter: string = '';
    public selectedEvidence: any = null;
    public editingCandidate: any = null;
    public reviewReason: string = '';
    public reviewer: string = '';
    public canWrite: boolean = false;
    public editName: string = '';
    public editType: string = '';
    public editEvidenceText: string = '';
    public editEvidenceStart: number = 0;
    public editEvidenceEnd: number = 0;
    public identityLoading: boolean = false;
    public identityBusy: boolean = false;
    public identityWorkspace: any = {
        canonical_entities: [],
        resolution_candidates: [],
        suggestions: [],
        decisions: [],
        audit_events: [],
        stats: {}
    };
    public identityQuery: string = '';
    public identityStatusFilter: string = '';
    public selectedIdentitySuggestion: any = null;
    public identityActionMode: string = 'resolve';
    public identityReason: string = '';
    public selectedIdentityCandidateIds: string[] = [];
    public graphReviewMode: boolean = false;
    public reviewEntryStep: 'candidates' | 'identity' = 'candidates';

    private contextRequestSequence: number = 0;
    private requestedDocumentId: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const query = new URLSearchParams(location.search);
        this.graphReviewMode = query.get('review_mode') === 'graph';
        this.reviewEntryStep = query.get('review_step') === 'identity'
            ? 'identity' : 'candidates';
        this.requestedDocumentId = String(query.get('document_id') || '').trim();
        const session = this.service.auth.session || {};
        this.reviewer = String(session?.id || '');
        this.canWrite = ['admin', 'editor'].includes(
            String(session?.role || '').toLowerCase()
        ) && !!this.reviewer;
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('overview', {});
            if (response.code !== 200) {
                this.errorMessage = response.data?.message || '추출 대상을 불러오지 못했습니다.';
                return;
            }
            this.documents = response.data?.documents || [];
            this.quality = response.data?.quality || {};
            this.ontology = response.data?.ontology || {};
            if (!this.selectedDocumentId && this.documents.length) {
                const requestedDocument = this.documents.find((item) =>
                    String(item?.id || '') === this.requestedDocumentId
                );
                const baekdu = this.documents.find((item) =>
                    String(item?.title || '').replace(/\s/g, '').includes('백두산정계비자료집')
                );
                this.selectedDocumentId = (requestedDocument || baekdu || this.documents[0]).id;
            }
            await Promise.all([
                this.loadContexts(),
                this.loadIdentityWorkspace()
            ]);
        } catch (_error) {
            this.errorMessage = '추출 대상을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
            this.scrollToReviewEntry();
        }
    }

    public graphReviewReturnUrl(): string {
        const query = new URLSearchParams();
        if (this.selectedDocumentId) query.set('document_id', this.selectedDocumentId);
        query.set('review_stage', 'relations');
        return `/graph?${query.toString()}#relation-source-review`;
    }

    public selectedRunRecommendationLabel(): string {
        const run = this.selectedRun();
        if (!run) return '저장된 추천 실행 없음';
        return `${this.isHistoricalRun() ? '과거 추천' : '현재 추천'} · ${run.id}`;
    }

    public identityRecommendationVersionLabel(item: any): string {
        const details = this.identityCandidateDetails(item);
        const ontologyVersions = Array.from(new Set(
            details.map((detail: any) => String(detail?.ontology_version || '')).filter(Boolean)
        ));
        const runIds = Array.from(new Set(
            details.map((detail: any) => String(detail?.extraction_run_id || '')).filter(Boolean)
        ));
        const versionLabel = ontologyVersions.length
            ? `Ontology v${ontologyVersions.join(', ')}` : 'Ontology 버전 없음';
        return `${versionLabel} · 추출 실행 ${runIds.length || 0}개에서 생성된 추천`;
    }

    private scrollToReviewEntry() {
        if (!this.graphReviewMode) return;
        const targetId = this.reviewEntryStep === 'identity'
            ? 'entity-resolution' : 'candidate-recommendations';
        setTimeout(() => {
            document.getElementById(targetId)?.scrollIntoView({
                behavior: 'smooth', block: 'start'
            });
        }, 80);
    }

    public async loadContexts() {
        const documentId = this.selectedDocumentId;
        this.contextRequestSequence += 1;
        this.contexts = [];
        this.selectedContext = {};
        this.selectedContextId = '';
        this.extractionRuns = [];
        this.currentRunId = '';
        this.selectedRunId = '';
        this.candidates = {
            entity_candidates: [],
            event_candidates: [],
            relation_candidates: []
        };
        if (!documentId) return;

        const response = await wiz.call('contexts', {
            document_id: documentId
        });
        if (documentId !== this.selectedDocumentId) return;
        if (response.code !== 200) {
            this.errorMessage = response.data?.message || '처리 단위를 불러오지 못했습니다.';
            return;
        }

        this.contexts = response.data?.contexts || [];
        const evidenceContext = this.contexts.find(
            (item) => item?.is_default_evidence_context === true
        );
        this.selectedContextId = (evidenceContext || this.contexts[0])?.context_id || '';
        await this.selectContext();
    }

    private async loadContextDetail(
        documentId: string,
        contextId: string,
        requestSequence: number
    ) {
        const response = await wiz.call('context_detail', {
            document_id: documentId,
            context_id: contextId
        });
        if (
            requestSequence !== this.contextRequestSequence
            || documentId !== this.selectedDocumentId
            || contextId !== this.selectedContextId
        ) return;
        if (response.code !== 200) {
            this.errorMessage = response.data?.message || '처리 단위 원문을 불러오지 못했습니다.';
            return;
        }

        const detail = response.data?.context || {};
        this.selectedContext = {
            ...this.selectedContext,
            ...detail
        };
    }

    public async loadCandidates(
        documentId: string = this.selectedDocumentId,
        contextId: string = this.selectedContextId,
        runId: string = this.selectedRunId
    ) {
        if (!documentId || !contextId) return;
        const response = await wiz.call('candidates', {
            document_id: documentId,
            context_id: contextId,
            run_id: runId || ''
        });
        if (
            documentId !== this.selectedDocumentId
            || contextId !== this.selectedContextId
        ) return;
        if (response.code !== 200) {
            this.errorMessage = response.data?.message || '저장된 후보를 불러오지 못했습니다.';
            return;
        }
        this.candidates = {
            entity_candidates: response.data?.entity_candidates || [],
            event_candidates: response.data?.event_candidates || [],
            relation_candidates: response.data?.relation_candidates || []
        };
    }

    public async loadRunHistory(
        documentId: string = this.selectedDocumentId,
        contextId: string = this.selectedContextId
    ) {
        if (!documentId || !contextId) return;
        const response = await wiz.call('runs', {
            document_id: documentId,
            context_id: contextId
        });
        if (
            documentId !== this.selectedDocumentId
            || contextId !== this.selectedContextId
        ) return;
        if (response.code !== 200) {
            this.errorMessage = response.data?.message || '추출 실행 이력을 불러오지 못했습니다.';
            return;
        }
        this.extractionRuns = response.data?.runs || [];
        this.currentRunId = String(response.data?.current_run_id || '');
        this.selectedRunId = this.currentRunId
            || String(this.extractionRuns[0]?.id || '');
    }

    public async runChanged() {
        this.selectedEvidence = null;
        this.editingCandidate = null;
        this.errorMessage = '';
        this.contextLoading = true;
        await this.service.render();
        try {
            await this.loadCandidates(
                this.selectedDocumentId,
                this.selectedContextId,
                this.selectedRunId
            );
        } catch (_error) {
            this.errorMessage = '선택한 추출 실행의 후보를 불러오지 못했습니다.';
        } finally {
            this.contextLoading = false;
            await this.service.render();
        }
    }

    public async documentChanged() {
        this.run = null;
        this.extractionRuns = [];
        this.currentRunId = '';
        this.selectedRunId = '';
        this.batchResult = null;
        this.selectedEvidence = null;
        this.editingCandidate = null;
        await Promise.all([
            this.loadContexts(),
            this.loadIdentityWorkspace()
        ]);
        await this.service.render();
    }

    public async loadIdentityWorkspace() {
        if (!this.selectedDocumentId) return;
        this.identityLoading = true;
        await this.service.render();
        try {
            const response = await wiz.call('identity_workspace', {
                document_id: this.selectedDocumentId,
                status: this.identityStatusFilter,
                query: this.identityQuery.trim()
            });
            if (response.code !== 200) {
                this.errorMessage = response.data?.message || '동일 개체 판별 작업공간을 불러오지 못했습니다.';
                return;
            }
            this.identityWorkspace = response.data || {};
            this.selectedIdentitySuggestion = null;
            this.identityActionMode = 'resolve';
            this.identityReason = '';
            this.selectedIdentityCandidateIds = [];
        } catch (_error) {
            this.errorMessage = '동일 개체 판별 작업공간을 불러오지 못했습니다.';
        } finally {
            this.identityLoading = false;
            await this.service.render();
        }
    }

    public identitySuggestions(): any[] {
        if (this.identityStatusFilter === 'merged') {
            return this.identityMergedGroups();
        }
        const suggestions = this.identityWorkspace?.suggestions || [];
        return suggestions.length
            ? suggestions
            : (this.identityWorkspace?.resolution_candidates || []);
    }

    public identityMergedGroups(): any[] {
        const rows = this.identityWorkspace?.resolution_candidates || [];
        const canonical = new Map(
            (this.identityWorkspace?.canonical_entities || []).map(
                (item: any) => [String(item?.id || ''), item]
            )
        );
        const groups = new Map<string, any[]>();
        rows.forEach((item: any) => {
            const canonicalId = String(item?.canonical_entity_id || '');
            if (!canonicalId) return;
            if (!groups.has(canonicalId)) groups.set(canonicalId, []);
            groups.get(canonicalId)?.push(item);
        });
        return Array.from(groups.entries())
            .filter((entry: any) => entry[1].length > 1)
            .map(([canonicalId, details]: any) => {
                const node: any = canonical.get(canonicalId) || {};
                return {
                    suggestion: 'merged_cluster',
                    status: 'merged',
                    canonical_entity_id: canonicalId,
                    canonical_name: node?.canonical_name
                        || details[0]?.canonical_name
                        || details[0]?.label,
                    normalized_label: node?.canonical_name
                        || details[0]?.canonical_name
                        || details[0]?.label,
                    candidate_ids: details.map((item: any) => item.id),
                    candidate_labels: details.map((item: any) => item.label),
                    candidate_details: details,
                    candidates: details,
                    evidence_count: details.filter((item: any) => item?.evidence_text).length,
                    active_candidate_count: details.length
                };
            })
            .sort((left: any, right: any) =>
                String(left.canonical_name).localeCompare(String(right.canonical_name), 'ko')
            );
    }

    public identityCandidateIds(item: any): string[] {
        const grouped = item?.candidate_ids
            || item?.entity_candidate_ids
            || [item?.left_candidate_id, item?.right_candidate_id];
        const values = Array.isArray(grouped) && grouped.some(Boolean)
            ? grouped
            : [item?.id];
        return Array.isArray(values)
            ? values.map((value) => String(value || '').trim()).filter(Boolean)
            : [];
    }

    public identityCandidateLabels(item: any): string {
        const labels = item?.candidate_labels || item?.labels || item?.names || [];
        if (Array.isArray(labels) && labels.length) {
            const unique = Array.from(new Set(labels.map(String)));
            return unique.length > 3
                ? `${unique.slice(0, 3).join(' ↔ ')} 외 ${unique.length - 3}종`
                : unique.join(' ↔ ');
        }
        return item?.normalized_label || item?.canonical_name
            || this.identityCandidateIds(item).join(' ↔ ')
            || '판별 대상';
    }

    public identityCandidateDetails(item: any): any[] {
        const embedded = item?.candidate_details || item?.candidates || [];
        if (Array.isArray(embedded) && embedded.length) return embedded;
        const rows = this.identityWorkspace?.resolution_candidates || [];
        return this.identityCandidateIds(item).map((candidateId) =>
            rows.find((candidate: any) => String(candidate?.id) === candidateId)
        ).filter(Boolean);
    }

    public identityPreviewDetails(item: any): any[] {
        return this.identityCandidateDetails(item).slice(0, 4);
    }

    public identityHiddenDetailCount(item: any): number {
        return Math.max(0, this.identityCandidateDetails(item).length - 4);
    }

    public identityCandidateSelected(candidateId: any): boolean {
        return this.selectedIdentityCandidateIds.includes(String(candidateId || ''));
    }

    public async toggleIdentityCandidate(candidateId: any) {
        const value = String(candidateId || '').trim();
        if (!value) return;
        const selected = new Set(this.selectedIdentityCandidateIds);
        if (selected.has(value)) selected.delete(value);
        else if (selected.size < 100) selected.add(value);
        this.selectedIdentityCandidateIds = Array.from(selected);
        await this.service.render();
    }

    public async clearIdentityCandidateSelection() {
        this.selectedIdentityCandidateIds = [];
        await this.service.render();
    }

    public identitySelectedDetails(): any[] {
        const selected = new Set(this.selectedIdentityCandidateIds);
        return this.identityCandidateDetails(this.selectedIdentitySuggestion)
            .filter((item: any) => selected.has(String(item?.id || '')));
    }

    public identitySelectionHasTypeConflict(): boolean {
        const values = new Set(
            this.identitySelectedDetails().map((item: any) =>
                `${item?.candidate_kind || item?.kind || ''}:${item?.node_type || ''}`
            )
        );
        return values.size > 1;
    }

    public identitySelectionHasTemporalConflict(): boolean {
        const anchors = new Set<string>();
        this.identitySelectedDetails().forEach((item: any) => {
            const value = String(item?.temporal_anchor || '').trim();
            value.split('|').map((part) => part.trim()).filter(Boolean)
                .forEach((part) => anchors.add(part));
        });
        return anchors.size > 1;
    }

    public identitySelectionMessage(): string {
        const count = this.selectedIdentityCandidateIds.length;
        const total = this.identityCandidateIds(this.selectedIdentitySuggestion).length;
        if (this.identityActionMode === 'split') {
            if (!count) return '기존 대표 노드에서 분리할 후보를 선택하세요.';
            if (count >= total) return '최소 한 후보는 기존 대표 노드에 남겨야 합니다.';
            return `${count}개 후보를 각각 독립 대표 노드로 분리합니다.`;
        }
        if (count < 2) return '비교할 후보를 2개 이상 선택하세요.';
        if (this.identitySelectionHasTypeConflict()) {
            return '유형이 다른 후보는 병합할 수 없습니다.';
        }
        if (this.identitySelectionHasTemporalConflict()) {
            return '명시적 시기가 충돌합니다. 병합하지 말고 별도 유지하세요.';
        }
        return `${count}개 후보의 원문·유형·시기 단서를 비교할 수 있습니다.`;
    }

    public canResolveIdentity(action: string): boolean {
        if (this.identityBusy || !this.canWrite || !this.identityReason.trim()) return false;
        const count = this.selectedIdentityCandidateIds.length;
        const total = this.identityCandidateIds(this.selectedIdentitySuggestion).length;
        if (action === 'split') return count > 0 && count < total;
        if (count < 2 || this.identitySelectionHasTypeConflict()) return false;
        if (action === 'merge' && this.identitySelectionHasTemporalConflict()) return false;
        return true;
    }

    public identityEvidenceSummary(item: any): string {
        const details = this.identityCandidateDetails(item);
        const evidence = item?.evidence || item?.evidence_spans || [];
        const count = details.filter((detail) =>
            !!detail?.evidence_text || (detail?.evidence || []).length
        ).length || (Array.isArray(evidence)
            ? evidence.length : Number(item?.evidence_count || 0));
        const temporal = item?.temporal_anchor
            || item?.temporal_compatibility
            || item?.temporal_status
            || '시기 단서 검토';
        return `원문 근거 ${count}개 · ${temporal}`;
    }

    public identityTemporalLabel(detail: any, suggestion: any): string {
        const values = detail?.temporal_anchors
            || detail?.identity_features?.temporal_anchors
            || suggestion?.temporal_anchors
            || [];
        if (Array.isArray(values) && values.length) return values.join(', ');
        return String(
            detail?.temporal_anchor
            || detail?.identity_features?.temporal_anchor
            || suggestion?.temporal_anchor
            || '명시적 시기 단서 없음'
        );
    }

    public identityStrongFeatures(detail: any, suggestion: any): string[] {
        const raw = detail?.strong_identity_features
            || detail?.identity_features?.strong_identity_features
            || suggestion?.strong_identity_features
            || [];
        if (Array.isArray(raw)) return raw.map(String).filter(Boolean);
        if (raw && typeof raw === 'object') {
            return Object.entries(raw)
                .filter((entry: any) => entry[1] !== null && entry[1] !== '' && entry[1] !== false)
                .map((entry: any) => `${entry[0]}: ${entry[1]}`);
        }
        return raw ? [String(raw)] : [];
    }

    public identityContextId(detail: any): string {
        return String(
            detail?.processing_chunk_id
            || detail?.context_id
            || detail?.source_chunk_id
            || '-'
        );
    }

    public async startIdentityReview(item: any) {
        this.selectedIdentitySuggestion = item;
        this.identityActionMode = item?.suggestion === 'merged_cluster'
            ? 'split'
            : 'resolve';
        this.identityReason = '';
        const candidateIds = this.identityCandidateIds(item);
        this.selectedIdentityCandidateIds = (
            this.identityActionMode === 'resolve' && candidateIds.length === 2
        ) ? candidateIds : [];
        await this.service.render();
    }

    public async cancelIdentityReview() {
        this.selectedIdentitySuggestion = null;
        this.identityActionMode = 'resolve';
        this.identityReason = '';
        this.selectedIdentityCandidateIds = [];
        await this.service.render();
    }

    public async resolveIdentity(action: string, decision: any = null) {
        if (!this.canWrite || !this.reviewer.trim() || !this.identityReason.trim()) {
            this.errorMessage = 'admin 또는 editor 권한의 로그인 세션과 판별 사유가 필요합니다.';
            await this.service.render();
            return;
        }
        const target = decision || this.selectedIdentitySuggestion || {};
        const candidateIds = action === 'undo'
            ? []
            : [...this.selectedIdentityCandidateIds];
        const minimum = action === 'split' ? 1 : 2;
        if (action !== 'undo' && candidateIds.length < minimum) {
            this.errorMessage = '판별할 개체·사건 후보를 선택해주세요.';
            await this.service.render();
            return;
        }
        this.identityBusy = true;
        this.errorMessage = '';
        this.successMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('resolve_identity', {
                action,
                candidate_ids: JSON.stringify(candidateIds),
                canonical_entity_id: target?.canonical_entity_id || '',
                decision_id: action === 'undo' ? String(target?.id || target?.decision_id || '') : '',
                reason: this.identityReason.trim()
            });
            if (response.code !== 200) {
                this.errorMessage = response.data?.message || '동일 개체 판별 결정을 저장하지 못했습니다.';
            } else {
                const labels: any = {
                    merge: '동일 대표 노드로 연결',
                    keep_separate: '별도 대표 노드로 유지',
                    split: '병합된 대표 노드에서 분리',
                    undo: '판별 결정 취소'
                };
                this.successMessage = `${labels[action] || action} 결정과 감사 이력을 저장했습니다.`;
                await this.loadIdentityWorkspace();
            }
        } catch (_error) {
            this.errorMessage = '동일 개체·사건 판별 결정을 저장하지 못했습니다.';
        } finally {
            this.identityBusy = false;
            await this.service.render();
        }
    }

    public async startUndoIdentity(decision: any) {
        this.selectedIdentitySuggestion = decision;
        this.identityActionMode = 'undo';
        this.identityReason = '';
        this.selectedIdentityCandidateIds = [];
        await this.service.render();
    }

    public async selectContext() {
        const documentId = this.selectedDocumentId;
        const contextId = this.selectedContextId;
        const requestSequence = ++this.contextRequestSequence;
        this.selectedContext = this.contexts.find(
            (item) => item.context_id === contextId
        ) || {};
        this.run = null;
        this.extractionRuns = [];
        this.currentRunId = '';
        this.selectedRunId = '';
        this.selectedEvidence = null;
        this.editingCandidate = null;
        this.errorMessage = '';
        if (!documentId || !contextId) {
            await this.service.render();
            return;
        }

        this.contextLoading = true;
        await this.service.render();
        try {
            await Promise.all([
                this.loadContextDetail(documentId, contextId, requestSequence),
                this.loadRunHistory(documentId, contextId),
                this.loadCandidates(documentId, contextId)
            ]);
        } catch (_error) {
            if (requestSequence === this.contextRequestSequence) {
                this.errorMessage = '처리 단위 원문과 후보를 불러오지 못했습니다.';
            }
        } finally {
            if (requestSequence === this.contextRequestSequence) {
                this.contextLoading = false;
                await this.service.render();
            }
        }
    }

    public async extract() {
        if (!this.selectedDocumentId || !this.selectedContextId) return;
        if (this.isHistoricalRun()) {
            this.errorMessage = '과거 실행은 읽기 전용입니다. 현재 실행으로 돌아가 추출해주세요.';
            await this.service.render();
            return;
        }
        this.extracting = true;
        this.errorMessage = '';
        this.successMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('extract', {
                document_id: this.selectedDocumentId,
                context_id: this.selectedContextId,
                run_id: this.selectedRunId || ''
            });
            if (response.code !== 200) {
                this.errorMessage = response.data?.message || '후보 추출에 실패했습니다.';
            } else {
                this.run = response.data;
                this.successMessage = '후보와 원문 근거를 MySQL에 저장했습니다.';
                await this.loadRunHistory();
                await this.loadCandidates(
                    this.selectedDocumentId,
                    this.selectedContextId,
                    this.selectedRunId
                );
            }
        } catch (_error) {
            this.errorMessage = '후보 추출에 실패했습니다.';
        } finally {
            this.extracting = false;
            await this.service.render();
        }
    }

    public async extractDocument() {
        if (!this.selectedDocumentId) return;
        if (this.isHistoricalRun()) {
            this.errorMessage = '과거 실행을 보는 동안에는 문서 전체 추출을 시작할 수 없습니다.';
            await this.service.render();
            return;
        }
        const accepted = await this.service.modal.show({
            title: '문서 전체 후보 추출',
            message: '현재 문서의 모든 처리 조각을 순차 실행합니다. 원문 규모에 따라 시간이 걸릴 수 있습니다.',
            action: '실행',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!accepted) return;

        this.extracting = true;
        this.errorMessage = '';
        this.successMessage = '';
        this.batchResult = null;
        await this.service.render();
        try {
            const response = await wiz.call('extract_document', {
                document_id: this.selectedDocumentId,
                context_id: this.selectedContextId,
                run_id: this.selectedRunId || ''
            });
            if (response.code !== 200) {
                this.errorMessage = response.data?.message || '문서 전체 추출에 실패했습니다.';
            } else {
                this.batchResult = response.data;
                this.successMessage = '문서 전체 후보 추출을 완료했습니다.';
                await this.loadRunHistory();
                await this.loadCandidates(
                    this.selectedDocumentId,
                    this.selectedContextId,
                    this.selectedRunId
                );
            }
        } catch (_error) {
            this.errorMessage = '문서 전체 추출에 실패했습니다.';
        } finally {
            this.extracting = false;
            await this.service.render();
        }
    }

    public async refreshView() {
        await this.service.render();
    }

    public isHistoricalRun(): boolean {
        return !!this.selectedRunId && this.selectedRunId !== this.currentRunId;
    }

    public selectedRun(): any {
        return this.extractionRuns.find((item) => item?.id === this.selectedRunId) || null;
    }

    private runConfiguration(): any {
        const value = this.selectedRun()?.configuration || {};
        if (typeof value !== 'string') return value || {};
        try {
            return JSON.parse(value || '{}');
        } catch (_error) {
            return {};
        }
    }

    public runValue(...keys: string[]): any {
        const selected = this.selectedRun() || {};
        const configuration = this.runConfiguration();
        const metrics = selected.metrics || selected.counts || configuration.metrics || {};
        for (const key of keys) {
            if (selected[key] !== undefined && selected[key] !== null) return selected[key];
            if (configuration[key] !== undefined && configuration[key] !== null) return configuration[key];
            if (metrics[key] !== undefined && metrics[key] !== null) return metrics[key];
        }
        return '-';
    }

    public runOntologyLabel(): string {
        const selected = this.selectedRun() || {};
        const configuration = this.runConfiguration();
        const id = selected.ontology_id || configuration.ontology_id || '-';
        const version = selected.ontology_version || configuration.ontology_version || '-';
        return `${id} · v${version}`;
    }

    public runExtractorLabel(): string {
        const selected = this.selectedRun() || {};
        return `${selected.extractor_name || 'extractor'} · ${selected.extractor_version || '-'}`;
    }

    public runPromptLabel(): string {
        return String(this.runValue('prompt_version', 'model_version'));
    }

    public runCreatedLabel(): string {
        const value = this.selectedRun()?.created_at || this.selectedRun()?.completed_at;
        if (!value) return '-';
        const parsed = new Date(value);
        return Number.isNaN(parsed.getTime()) ? String(value) : parsed.toLocaleString('ko-KR');
    }

    public runOptionLabel(item: any): string {
        const scope = item?.id === this.currentRunId ? '현재' : '이력';
        return `${scope} · ${item?.extractor_version || '-'} · ${item?.created_at || item?.completed_at || '-'}`;
    }

    public async changeTab(tab: string) {
        this.activeTab = tab;
        this.editingCandidate = null;
        await this.service.render();
    }

    public get currentCandidates(): any[] {
        const key = this.activeTab === 'entity'
            ? 'entity_candidates'
            : this.activeTab === 'event'
                ? 'event_candidates'
                : 'relation_candidates';
        const rows = this.candidates?.[key] || [];
        if (!this.statusFilter) return rows;
        return rows.filter((item) => item.status === this.statusFilter);
    }

    public candidateCount(kind: string): number {
        const key = kind === 'entity'
            ? 'entity_candidates'
            : kind === 'event'
                ? 'event_candidates'
                : 'relation_candidates';
        return (this.candidates?.[key] || []).length;
    }

    public candidateName(item: any): string {
        if (this.activeTab === 'entity') return item?.candidate_name || item?.surface_text || item?.id;
        if (this.activeTab === 'event') return item?.event_name || item?.id;
        const subject = item?.subject_name || this.endpointName(item?.subject_candidate_id);
        const object = item?.object_name || this.endpointName(item?.object_candidate_id);
        return `${subject} — ${item?.predicate || '관계 미정'} → ${object}`;
    }

    public candidateType(item: any): string {
        if (this.activeTab === 'entity') return item?.entity_type || '유형 미정';
        if (this.activeTab === 'event') return item?.event_type || 'Event';
        return item?.predicate || '관계 미정';
    }

    public endpointName(candidateId: string): string {
        if (!candidateId) return '대상 없음';
        const rows = [
            ...(this.candidates?.entity_candidates || []),
            ...(this.candidates?.event_candidates || [])
        ];
        const matched = rows.find((item) => item.id === candidateId);
        return matched?.candidate_name || matched?.event_name || candidateId;
    }

    public mentionCount(item: any): number {
        return Array.isArray(item?.mention_ids) ? item.mention_ids.length : 0;
    }

    public extractionEvidenceLabel(item: any): string {
        if (item?.identity_features?.ambiguous_short_name) {
            return '명칭 경계 규칙 일치 · 의미 검토 필요';
        }
        if (item?.rule_match?.name) return `규칙 일치 · ${item.rule_match.name}`;
        const ruleName = item?.identity_features?.rule_name
            || item?.attributes?.rule_name
            || item?.qualifiers?.rule_name;
        return ruleName
            ? `규칙 일치 · ${ruleName}`
            : '결정적 사전·문형 규칙 일치';
    }

    public extractionEvidenceDetail(item: any): string {
        const conditions = item?.rule_match?.conditions
            || item?.identity_features?.matched_conditions
            || item?.attributes?.matched_conditions
            || item?.qualifiers?.matched_conditions
            || [];
        return Array.isArray(conditions) && conditions.length
            ? conditions.join(' · ')
            : '확률 점수가 아니라 충족한 추출 규칙을 표시합니다.';
    }

    public statusLabel(status: string): string {
        const labels: any = {
            candidate: '후보',
            needs_review: '검토 필요',
            approved: '승인',
            rejected: '제외'
        };
        return labels[status] || status || '후보';
    }

    public statusClass(status: string): string {
        if (status === 'approved') return 'bg-emerald-50 text-emerald-700';
        if (status === 'rejected') return 'bg-slate-100 text-slate-600';
        if (status === 'needs_review') return 'bg-amber-50 text-amber-800';
        return 'bg-violet-50 text-violet-700';
    }

    public async showEvidence(item: any) {
        this.selectedEvidence = item;
        await this.service.render();
        setTimeout(() => {
            document.getElementById('source-evidence-panel')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }, 0);
    }

    private evidenceBounds(): { start: number; end: number } {
        const text = String(this.selectedContext?.full_text || '');
        const start = Math.max(0, Math.min(Number(this.selectedEvidence?.evidence_start || 0), text.length));
        const end = Math.max(start, Math.min(Number(this.selectedEvidence?.evidence_end || start), text.length));
        return { start, end };
    }

    public evidenceBefore(): string {
        const bounds = this.evidenceBounds();
        return String(this.selectedContext?.full_text || '').slice(0, bounds.start);
    }

    public evidenceText(): string {
        const bounds = this.evidenceBounds();
        const source = String(this.selectedContext?.full_text || '').slice(bounds.start, bounds.end);
        return source || String(this.selectedEvidence?.evidence_text || '');
    }

    public evidenceAfter(): string {
        const bounds = this.evidenceBounds();
        return String(this.selectedContext?.full_text || '').slice(bounds.end);
    }

    public async startReview(item: any) {
        if (this.isHistoricalRun()) {
            this.errorMessage = '과거 실행의 후보는 읽기 전용이며 검토할 수 없습니다.';
            await this.service.render();
            return;
        }
        this.editingCandidate = item;
        this.reviewReason = '';
        this.editName = item?.candidate_name || item?.event_name || '';
        this.editType = item?.entity_type || item?.event_type || item?.predicate || '';
        this.editEvidenceText = item?.evidence_text || '';
        this.editEvidenceStart = Number(item?.evidence_start || 0);
        this.editEvidenceEnd = Number(item?.evidence_end || 0);
        await this.showEvidence(item);
    }

    public async cancelReview() {
        this.editingCandidate = null;
        this.reviewReason = '';
        await this.service.render();
    }

    public async saveReview(status: string) {
        if (this.isHistoricalRun()) {
            this.errorMessage = '과거 실행의 후보는 읽기 전용이며 검토 결과를 변경할 수 없습니다.';
            await this.service.render();
            return;
        }
        if (!this.editingCandidate || !this.canWrite || !this.reviewer.trim() || !this.reviewReason.trim()) {
            this.errorMessage = '검토 저장에는 admin 또는 editor 권한의 로그인 세션과 검토 사유가 필요합니다.';
            await this.service.render();
            return;
        }
        const updates: any = {
            evidence_text: this.editEvidenceText,
            evidence_start: Number(this.editEvidenceStart),
            evidence_end: Number(this.editEvidenceEnd)
        };
        if (this.activeTab === 'entity') {
            updates.candidate_name = this.editName;
            updates.entity_type = this.editType;
        } else if (this.activeTab === 'event') {
            updates.event_name = this.editName;
            updates.event_type = this.editType;
        } else {
            updates.predicate = this.editType;
        }

        this.reviewing = true;
        this.errorMessage = '';
        this.successMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('review_candidate', {
                kind: this.activeTab,
                candidate_id: this.editingCandidate.id,
                status,
                reason: this.reviewReason.trim(),
                updates: JSON.stringify(updates),
                document_id: this.selectedDocumentId,
                context_id: this.selectedContextId,
                run_id: this.selectedRunId || ''
            });
            if (response.code !== 200) {
                this.errorMessage = response.data?.message || '후보 검토 결과를 저장하지 못했습니다.';
            } else {
                this.successMessage = `${this.statusLabel(status)} 상태와 검토 이력을 저장했습니다.`;
                this.editingCandidate = null;
                await this.loadCandidates(
                    this.selectedDocumentId,
                    this.selectedContextId,
                    this.selectedRunId
                );
            }
        } catch (_error) {
            this.errorMessage = '후보 검토 결과를 저장하지 못했습니다.';
        } finally {
            this.reviewing = false;
            await this.service.render();
        }
    }

    public headingPath(): string {
        const path = this.selectedContext?.heading_path || [];
        return path.length ? path.join(' › ') : '제목 경로 없음';
    }

    public selectedDocumentTitle(): string {
        return this.documents.find((item) => item.id === this.selectedDocumentId)?.title || '';
    }

    public runCandidateCount(kind: string): number {
        const key = `${kind}_candidates`;
        return (this.run?.[key] || []).length;
    }
}

export default PageExtractionComponent;